module.exports = __webpack_public_path__ + "static/media/11Labs35YearsOfAI.1c4a3bca.mp4";